import { useEffect, useFlag } from '.'

const useUserSnapEffect = () => {
  const isUsersnapEnabled = useFlag('Usersnap')

  useEffect(() => {
    if (isUsersnapEnabled) {
      const mutableScript = document.createElement('script')
      mutableScript.type = 'text/javascript'
      mutableScript.async = true
      mutableScript.src =
        '//api.usersnap.com/load/e00dd5b1-8ec8-4ab5-b5c6-ca140a3a1268.js'
      const x = document.getElementsByTagName('script')[0]
      x.parentNode?.insertBefore(mutableScript, x)
    }
  }, [isUsersnapEnabled])
}

export default useUserSnapEffect
